import { render, staticRenderFns } from "./AdminCustomerView.vue?vue&type=template&id=95a33bb6&scoped=true"
import script from "./AdminCustomerView.vue?vue&type=script&lang=js"
export * from "./AdminCustomerView.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomerView.vue?vue&type=style&index=0&id=95a33bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a33bb6",
  null
  
)

export default component.exports